import { memo } from "react";
import usePurchases from "../../hooks/usePurchases";
import Option from "./components/Option";

import styles from "./styles.module.scss";

/**
 * Represents list of option to select.
 * Such as yearly or monthly time period or amount of JUMBOcodes.
 *
 * Uses for purchase plans or for pay-as-you-go.
 */

const OptionList = memo(() => {
  const { options } = usePurchases();

  return (
    <ul className={styles.wrapper}>
      {options?.map((option) => (
        <Option type={option} key={option} />
      ))}
    </ul>
  );
});

export default OptionList;
